/**
 * Sayfa başına TEK tıklama dinleyicisi.
 *
 * NEDEN GEREKLİ: Bazı ekranlar bir işlemden sonra kendilerini baştan
 * çiziyor (`renderXPage(container)` kendi içinden tekrar çağrılıyor).
 * `container.innerHTML` değişse bile container ELEMENTİN KENDİSİ aynı
 * kalır — dolayısıyla ona bağlanan dinleyici de silinmez. Her yeniden
 * çizimde bir dinleyici daha eklenince, tek bir dokunuş birikmiş
 * dinleyicilerin hepsini tetikler:
 *
 * - Ödüller'de "Kullan": 100 puan bir kez yerine iki kez düşebilir.
 * - Temizlik'te bir göreve dokunmak: önce işaretler, sonra hemen geri
 *   alır (iki kez tetiklendiği için).
 *
 * Çözüm: dinleyiciyi eklemeden ÖNCE o sayfanın bir önceki
 * dinleyicisini kaldırmak. Sayfaların hepsi aynı container'ı
 * paylaştığı için kayıt, container'a değil SAYFA KİMLİĞİNE göre
 * tutuluyor.
 */

interface Registration {
  container: HTMLElement;
  handler: EventListener;
}

/** Sayfa kimliği → o sayfanın şu an bağlı olan dinleyicisi. */
const activeHandlers = new Map<string, Registration>();

/**
 * Bir sayfanın delege tıklama dinleyicisini kurar; öncekini kaldırır.
 *
 * @param pageId    Sayfaya özgü sabit bir ad (örn. `'rewards'`).
 * @param container Dinleyicinin bağlanacağı element.
 * @param handler   Tıklama işleyicisi.
 */
export function setDelegatedClick(
  pageId: string,
  container: HTMLElement,
  handler: (event: MouseEvent) => void,
): void {
  const previous = activeHandlers.get(pageId);
  if (previous) {
    previous.container.removeEventListener('click', previous.handler);
  }

  const listener = handler as EventListener;
  container.addEventListener('click', listener);
  activeHandlers.set(pageId, { container, handler: listener });
}
